import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import {
  QueryRepository,
  QueryRepositoryUID,
} from "@radarly/core/queries/repositories/QueryRepository";

export function useQueryValidity(query: string) {
  const repository = useInjection<QueryRepository>(QueryRepositoryUID);
  const { data, isFetching } = useQuery(
    ["/query/validity", query],
    async () => {
      const searchQueryInfo = await repository.getQueryValidity(query);
      return { query, ...searchQueryInfo };
    },
    {
      staleTime: 300_000, // 5 minutes
      keepPreviousData: true,
      onError: (err) => {
        return err;
      },
    }
  );
  return {
    ...data,
    isQueryBuilderCompatible: data?.isQueryBuilderCompatible ?? true,
    isLoading: isFetching,
  };
}
